import { LocalizationManager, useLocalization } from '@lib/localization';
import { CardContent, FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material';
import { CardHeader, CardTitle } from './Settings.styled';

const LanguageCard = () => {
  const { t, currentLanguage, changeLanguage } = useLocalization();

  const getLanguageName = (localeCode: string, displayLocale: string = currentLanguage) => {
    const displayNames = new Intl.DisplayNames([displayLocale], { type: 'language' });

    return displayNames.of(localeCode);
  };

  const localeEntries = LocalizationManager.supportedLanguageCodes
    .map(localeCode => [localeCode, getLanguageName(localeCode, localeCode)]);

  const locales = Object.fromEntries(localeEntries) as Record<string, string | undefined>;

  return (
    <Paper sx={{ mb: 2 }}>
      <CardHeader>
        <CardTitle variant="h6">{t('Settings_Language')}</CardTitle>
      </CardHeader>
      <CardContent style={{ padding: '24px' }}>
        <FormControl fullWidth size="small">
          <InputLabel id="language-select-label">{t('Settings_Language_Select')}</InputLabel>
          <Select
            labelId="language-select-label"
            value={currentLanguage}
            onChange={(e) => changeLanguage(e.target.value)}
            label={t('Settings_Language_Select')}
          >
            {Object.entries(locales).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label ?? key}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </CardContent>
    </Paper>
  );
};

export default LanguageCard;
